import { normalizePaymentPhone } from "@/lib/cashfree/paymentContact";

interface PaymentPhoneFieldProps {
  value: string;
  onChange: (value: string) => void;
  dark?: boolean;
}

const PaymentPhoneField = ({ value, onChange, dark = false }: PaymentPhoneFieldProps) => {
  const hasError = value.length > 0 && !normalizePaymentPhone(value);

  return (
    <div className="space-y-1.5">
      <label
        htmlFor="payment-phone"
        className={`block text-sm font-medium ${dark ? "text-gray-200" : "text-gray-700"}`}>
        Mobile number for payment
      </label>
      <input
        id="payment-phone"
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="10-digit mobile number"
        aria-invalid={hasError}
        className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-purple-500 ${
          dark
            ? "border-gray-700 bg-dark-3 text-white placeholder:text-gray-500"
            : "border-gray-300 bg-white text-gray-900 placeholder:text-gray-400"
        } ${hasError ? "border-red-500" : ""}`}
      />
      <p className={`text-xs ${hasError ? "text-red-500" : dark ? "text-gray-400" : "text-gray-500"}`}>
        {hasError
          ? "Enter a valid 10-digit Indian number or an international number with country code."
          : "Cashfree requires a valid mobile number to create the payment order."}
      </p>
    </div>
  );
};

export default PaymentPhoneField;
